import React from "react";
import InvoiceTable from "../../../component/InvoiceTable";

const TablePurchaseOrder = ({ tableData }) => {
  // console.log("tableData inside -====>>", tableData);

  const transformedData = tableData.item.map((item, index) => ({
    item: {
      value: (
        <div className="w-44">{item.item_name && <span>{item.item_name}</span>}</div>
      ),
    },
    avg: {
      value: (
        <div className="w-44">{item.avg}</div>
      ),
    },
    colQty: {
      value: (
        <div className="w-44">{item.colQty}</div>
      ),
    },
    quantity: {
      value: (
        <div className="w-44"> {item.quantity}</div>
      ),
    },
    unit: {
      value: (
        <div className="w-24 h-10">{item.unit}</div>
      ),
    },
    rate: {
      value: (
        <div className="w-24 h-10"> ₹{item.rate}</div>
      ),
    },
    total: {
      value: (
        <div className="w-24 h-10">₹{item.total}</div>
      ),
    },
  }))

  const columns = ["Item *", "Avg (1 Pcs) *", "1 Col. Qty", "Quantity", "Unit *", "Rate", "Total"];

  return (
    <div className="md:px-5 px-2">
      <InvoiceTable
        data={transformedData}
        columns={columns}
        checkbox={false}
        defaultRowSelected={[0]}
      />
    </div>
  );
};

export default TablePurchaseOrder;
